import { PDFDocument } from 'pdf-lib';

export const imageToPdf = async (file, type) => {
  const pdfDoc = await PDFDocument.create();

  const fileArrayBuffer = await file.arrayBuffer();

  let dataImage;
  if (type === "image/png") {
    dataImage = await pdfDoc.embedPng(fileArrayBuffer);
  } else {
    dataImage = await pdfDoc.embedJpg(fileArrayBuffer);
  }



  const page = pdfDoc.addPage();

  const scaled = dataImage.scaleToFit(page.getWidth(), page.getHeight());

  page.drawImage(dataImage, {
    x: 0,
    y: page.getHeight() - scaled.height,
    width: scaled.width,
    height: scaled.height,
  });

  return await pdfDoc.save();
}